import React from 'react';
import Form from 'mobx-react-form';
import { observer } from 'mobx-react-lite';
import { FormGroup, Stack, Typography, Grid, Paper, TextField } from '@mui/material';

import SalesHistory from './SalesHistory';

type PropertyHistoryProps = {
  form: Form;
};

const PropertyHistory = observer(({ form }: PropertyHistoryProps) => {
  return (
    <Paper elevation={0}>
      <Grid item xs={12}>
        <Typography variant="h6">Property History</Typography>
      </Grid>

      <Grid item xs={6}>
        <TextField
          {...form.$('property.currentOwner').bind()}
          size="small"
          margin="normal"
          label="Current Owner"
          fullWidth
        />
      </Grid>

      <Grid item xs={12}>
        <FormGroup>
          <Stack spacing={1}>
            <Typography variant="subtitle2" sx={{ marginTop: '24px', marginBottom: '16px' }}>
              Sales History
            </Typography>
            <SalesHistory form={form} />
          </Stack>
        </FormGroup>
      </Grid>
    </Paper>
  );
});

export { PropertyHistory };
